import React, { useContext } from "react"
import { AgreementContext } from "../../../../context/AgreementContext"

const Terms = () => {
  const { createAppLink } = useContext(AgreementContext)

  return (
    <>
      <p>
        <strong>
          Section 23 of these Terms contains an arbitration agreement and class
          action waiver that apply to all claims brought against Teache in the
          United States. Please read them carefully.
        </strong>
      </p>
      <p>Last Updated: March 15, 2023</p>
      <p>Thanks for using Teache!</p>
      <p>
        These Terms of Use (&ldquo;<strong>Terms</strong>&rdquo;) are a binding
        legal agreement between you and Teache that governs your use of the
        websites, applications, and other offerings from Teache (collectively,
        the &ldquo;<strong>Teache Platform</strong>&rdquo;). When used in these
        Terms, &ldquo;<strong>Teache</strong>,&rdquo; &ldquo;<strong>we</strong>
        ,&rdquo; &ldquo;<strong>us</strong>,&rdquo; or &ldquo;
        <strong>our</strong>&rdquo; refers to the Teache entity set out on&nbsp;
        <a href='#schedule-1'>Schedule 1,</a>&nbsp;with whom you are
        contracting.
      </p>
      <p>
        The Teache Platform offers an online venue that enables users (&ldquo;
        <strong>Members</strong>&rdquo;) to publish, offer, search for, and book
        services. Members who publish and offer services are &ldquo;
        <strong>Instructors,</strong>&rdquo; and Members who search for, book,
        or use services are &ldquo;<strong>Users</strong>.&rdquo; Instructors
        offer classes (&ldquo;<strong>Classes</strong>&rdquo;) and other
        services (collectively referred to as &ldquo;
        <strong>Instructor Services</strong>;&rdquo; each individual Instructor
        Service offering is referred to as a &ldquo;<strong>Listing</strong>
        &rdquo;), and the Classes are instructed online in our Teache Platform
        venue marketplace. You must register an account to access and use many
        features of the Teache Platform and keep your account information
        accurate. As the provider of the Teache Platform, Teache does not own,
        control, offer, or manage any Listings or Instructor Services. Teache is
        not a party to the contracts concluded directly between Instructors and
        Users, nor is Teache an insurer. Teache is not acting as an agent in any
        capacity for any Member, except as specified in the&nbsp;
        <a href={createAppLink("/policies/payment-terms")}>
          Payments Terms of Service
        </a>
        &nbsp;(&ldquo;<strong>Payment Terms</strong>&rdquo;). To learn more
        about Teache's role, see Section 16.
      </p>
      <p>
        We maintain other terms and policies that supplement these Terms, such
        as our&nbsp;
        <a href={createAppLink("/policies/privacy-policy")}>Privacy Policy</a>,
        which describes our collection and use of personal data, and our&nbsp;
        <a href={createAppLink("/policies/payment-terms")}>Payments Terms</a>,
        which govern any payment services provided to Members by the Teache
        payment entities.
      </p>
      <p>
        If you are an instructor, you are responsible for understanding and
        complying with all laws, rules, regulations, and contracts with third
        parties that apply to your Instructor Services.
      </p>
      <p>
        THE TEACHE PLATFORM IS AN ONLINE TEACHE PLATFORM THROUGH WHICH USERS
        SEARCH FOR INSTRUCTORS TO OFFER CLASSES PROVIDING GUIDANCE AND ADVICE TO
        USERS. USERS UNDERSTAND AND AGREE THAT TEACHE IS NOT A PARTY TO ANY
        AGREEMENTS ENTERED INTO BETWEEN INSTRUCTORS AND USERS. TEACHE HAS NO
        CONTROL OVER THE CONDUCT OF USERS OF THE PLATFORM OR ANY INFORMATION
        PROVIDED IN CONNECTION THERETO AND DISCLAIMS ALL LIABILITY IN THIS
        REGARD.
      </p>
      <p>
        <strong>User Terms</strong>
      </p>
      <ol>
        <li>
          <strong> Our Mission</strong>.
        </li>
      </ol>
      <p>
        Our mission is to create a world where communities work together to
        facilitate knowledge. From mathematics to cave diving, you can browse
        through millions of Classes and find the ones that pique your interest.
        Learn more about a Class by reviewing the description, the Instructor
        profile, and User reviews. If you have any questions, message the
        Instructor.
      </p>
      <ol start={2}>
        <li>
          <strong> Searching and Booking on Teache</strong>.
        </li>
      </ol>
      <p>
        <strong>2.1 Searching</strong>. You can search for Instructors by using
        criteria, such as the type of Class, dates offered, and time slots
        available. You can also use filters to refine your search results.
        Search results are based on their relevance to your search and other
        criteria. Relevance considers factors, such as price, availability,
        Reviews, and customer services, popularity, previous classes and saved
        Listings, Instructor requirements (e.g., special equipment), and more.
      </p>
      <p>
        <strong>2.2 Booking</strong>. When you book a Class, you agree to pay
        all charges for your booking, including the Class price, applicable
        fees, such as&nbsp;
        <a href={createAppLink("/policies/service-fees")}>
          Teache's service fee
        </a>
        ,&nbsp;
        <a href={createAppLink("/policies/taxes")}>taxes</a>, and any other
        items identified during checkout (collectively, &ldquo;
        <strong>Total Price</strong>
        &rdquo;). When you receive a class booking confirmation, a contract for
        Instructor Services (sometimes called a reservation in these Terms) is
        formed directly between you and your Instructor. The cancellation policy
        and any other rules, standards, policies, or requirements identified in
        the Listing or during checkout form part of your contract with the
        Instructor. Be aware that some Instructors work with a co-Instructor or
        as part of a team to provide their Instructor Services.
      </p>
      <p>
        <strong>2.3 Class Reservations</strong>. A Class reservation is a
        limited license to enter and participate in a Class. You are responsible
        for bringing specific equipment required for the class, as mentioned in
        the Class listing. You are responsible for confirming that you, and
        anyone you invite, meet minimum age, proficiency, fitness, or other
        requirements. You are responsible for informing the Instructor of any
        medical or physical conditions or other circumstances that may impact
        your ability to participate and attend the Instructor's Class. Except
        where expressly authorized, you may not allow any person to join a
        booked Class, unless they are included as an additional User during the
        booking process.
      </p>
      <p>
        The Instructor retains the right to stop the class and ask you to leave
        the Class to the extent that/in the event that (i) it is reasonably
        necessary, (ii) you do not follow the Instructor&rsquo;s class rules,
        and (iii) it is consistent with applicable law. Suppose that you
        don&rsquo;t leave the Class after being requested to do so by the
        instructor. In that case, the instructor has the right to make you leave
        in a manner consistent with applicable law, including by imposing
        reasonable penalties.
      </p>
      <ol start={3}>
        <li>
          <strong>
            {" "}
            Cancellations, Class Issues, Refunds, and Booking Modifications
          </strong>
          .
        </li>
      </ol>
      <p>
        <strong>3.1 Cancellations, Class Issues, and Refunds</strong>. In
        general, if, as a User, you cancel a Class reservation, the amount
        refunded to you is determined by the&nbsp;
        <a href={createAppLink("/policies/user-cancellation")}>
          cancellation policy
        </a>
        &nbsp;that applies to that reservation. However, in certain situations,
        other policies take precedence and determine what amount is refunded to
        you. If something outside your control forces you to cancel a
        reservation, you may be eligible for a partial or full refund.&nbsp;
        Suppose that the Instructor cancels or you experience a Class Issue (as
        defined in our&nbsp;User Refund Policy). In that case, you may be
        eligible for assistance with rebooking the Class assistance or for a
        partial or full refund under the&nbsp;
        <a href={createAppLink("/policies/user-refund")}>User Refund Policy</a>.
      </p>
      <p>
        <strong>3.2 Booking Modifications</strong>. Users and Instructors are
        responsible for any booking modifications they agree to make via the
        Teache Platform or which they direct Teache customer service to make on
        their behalf ("<strong>Booking Modifications</strong>"). They agree to
        pay any additional amounts, fees, or taxes associated with any Booking
        Modification.
      </p>
      <ol start={4}>
        <li>
          <strong> Your Responsibilities and Assumption of Risk</strong>.
        </li>
      </ol>
      <p>
        Users and Instructors engage on the Teache Platform when they mutually
        agree to a Class that stipulates the scope, fees and timing via the
        Teache Platform tool provided on the Teache Platform. The User initiates
        a Class by purchasing a Class selecting the Listing provided, and then
        following the steps set forth on the Class page. If you are a User and
        you initiate a Class, you agree to pay for the Instructor described in
        the Class Listing when you click the [&ldquo;Pay&rdquo;] button.&nbsp;
        All requests are subject to acceptance by the Instructor. The Instructor
        is not obligated to accept your request and may, at the
        Instructor&rsquo;s discretion, decline for any reason.
      </p>
      <p>
        Suppose that the Instructor has received a Class request from a User.In
        that case, you will be required to either confirm or reject the request
        within 24 hours of when the request is made (as determined by Company in
        its sole discretion), or the request will be automatically
        cancelled.When a Class is requested with you via the Teache Platform, we
        will share with you (i) the name of the User who has requested the
        Class, and (ii) a link to the User&rsquo;s Account profile page and the
        Listing, so that you can view this information before confirming or
        rejecting the Class. When you confirm a Class request, Company will send
        you an email, text message or message via the Teache Platform confirming
        such booking, depending on the selections you make via the Teache
        Platform.
      </p>
      <p>
        Teache's role is solely to facilitate the availability of the Teache
        Platform and to provide Services related thereto, such as Classes
        scheduling, payment integration and call facilitation. Teache does not
        provide and is not responsible for User Generated Content, or any
        information or advice exchanged between Users and Instructors during
        Classes or otherwise.&nbsp; User understands and acknowledges that
        Teache is not responsible for and disclaims any and all liability
        related to any and all Listings and information provided on the
        Platform. Accordingly, all users of the Teache Platform use it at their
        own risk.&nbsp; By using the Teache Platform, Users agree that any legal
        remedy or liability that they seek to obtain for actions or omissions of
        Instructors or other third parties will be limited to a claim against
        the particular Instructor or other third parties who caused User harm.
        You agree not to attempt to impose liability on or seek any legal remedy
        from Teache with respect to such actions or omissions.
      </p>
      <p>
        <strong>Instructor Terms</strong>
      </p>
      <ol start={5}>
        <li>
          <strong> Instructing on Teache</strong>.
        </li>
      </ol>
      <p>
        <strong>5.1 Instructor</strong>. As an Instructor, Teache allows you to
        share your knowledge of a subject with our vibrant community of Users -
        and earn money doing it. It&rsquo;s easy to create a Listing and you are
        in control. You set your price, availability, cancellation policy, and
        rules for each Listing.
      </p>
      <p>
        <strong>5.2 Contracting with Users</strong>. When you accept a booking
        request or receive a booking confirmation through the Teache Platform,
        you enter into a contract directly with the User. You are responsible
        for delivering your Instructor Service under the terms and at a price
        specified in your Listing. You are also agreeing to pay applicable fees,
        such as&nbsp;
        <a href={createAppLink("/policies/service-fees")}>
          Teache's service fee
        </a>
        &nbsp;(and applicable&nbsp;
        <a href={createAppLink("/policies/taxes")}>taxes</a>) for each booking.
        Teache will deduct the amounts you owe from your payout, unless you and
        Teache separately agree to a different method. Any terms, policies, or
        conditions that you include in any supplemental contract with Users
        must: (i) be consistent with these Terms, our Policies, and the
        information provided in your Listing, and (ii) be prominently disclosed
        in your Listing description.
      </p>
      <p>
        <strong>5.3 Independence of Instructors</strong>. Your relationship with
        Teache is that of an independent individual or entity and not an
        employee, agent, joint venturer, or partner of Teache, except that
        Teache acts as a payment collection agent, as described in the Payments
        Terms. Teache does not direct or control your Instructor Service. You
        agree that you have complete discretion as to whether and when to
        provide Instructor Services, what price to offer for Instructor Service,
        and on what terms you offer those services.
      </p>
      <ol start={6}>
        <li>
          <strong> Managing Your Listing</strong>.
        </li>
      </ol>
      <p>
        <strong>6.1 Creating and Managing Your Listing</strong>. The Teache
        Platform provides tools that make it easy for you to set up and manage a
        Listing. Your Listing must include complete and accurate information
        about your Class, your price, other charges, such as equipment
        fees,&nbsp;and any rules or requirements that apply to your Users or
        Classes. You are responsible for keeping your Listing information
        (always including calendar availability). We recommend carefully
        reviewing policy terms and conditions, including coverage details and
        exclusions.
      </p>
      <p>
        <strong>6.2 Know Your Legal Obligations</strong>. You are responsible
        for understanding and complying with any laws, rules, regulations, and
        contracts with third parties that apply to your Class Listing or
        Instructor Services.
      </p>
      <p>
        <strong>6.3 Search Ranking</strong>. The ranking of Listings in search
        results on the Teache Platform depends on a variety of factors,
        including these main parameters:
      </p>
      <ul>
        <li>
          User search parameters (e.g., number of Users, time, and price range)
        </li>
        <li>
          Class characteristics (e.g., price, calendar availability, number and
          quality of images Reviews, Class type, Instructor status, age of the
          Listing, and average User popularity),
        </li>
        <li>
          User booking experience (e.g., customer service and cancellation
          history of the Instructor, ease of booking)
        </li>
        <li>
          Instructor requirements (e.g., minimum or maximum experience required,
          special equipment), and
        </li>
        <li>
          User preferences (e.g., previous classes, the location from which the
          User is searching).
        </li>
      </ul>
      <p>
        Teache may allow Instructors to promote their Listings in search or
        elsewhere on the Teache Platform by paying an additional fee.
      </p>
      <p>
        <strong>6.4 Your Responsibilities</strong>. You are responsible and
        liable for your own acts and omissions. You are also responsible for the
        acts and omissions of anyone you allow to participate in providing your
        Instructor Services. You are responsible for setting your price and
        establishing rules and requirements for your Listing. You must describe
        any and all fees and charges in your Listing description and may not
        collect any additional fees or charges outside the Teache Platform. Do
        not encourage Users to create third-party accounts, submit reviews,
        provide their contact information, or take other actions outside the
        Teache Platform.
      </p>
      <p>
        <strong>6.5 Instructing as a Team or Organization</strong>. If you work
        with a co-Instructor or are instructing as part of a team, business, or
        other organization, the entity you are a part of and each individual who
        provides Instructor Services is responsible and liable as an Instructor
        under these Terms. Suppose that you accept terms or enter into
        contracts. In that case, you represent and warrant that you are
        authorized to enter into contracts for your team, business, or other
        organization and that each entity you use or are a part of is in good
        standing under the laws of the place where it is established. If you
        perform other functions, you represent and warrant that you are
        authorized to perform those functions. Suppose that you instruct Teache
        to transfer a portion of your payout to a co-Instructor or other
        Instructors or to send payments to someone else. In that case, you must
        be authorized to do so and are responsible and liable for the payment
        amounts and accuracy of any payout information you provide.
      </p>
      <p>
        <strong>6.6 Your Assumption of Risk</strong>.&nbsp;
        <strong>
          You acknowledge that Instructing carries inherent risks and agree that
          you assume the entire risk arising from your access to and use of the
          Teache Platform, offering Instructor Services, or any interaction you
          have with other Members, whether in person or online. You agree that
          you have had the opportunity to investigate the Teache Platform and
          any laws, rules, regulations, or obligations that may apply to your
          Listings or Instructor Services and that you are not relying upon any
          statement of law made by Teache.
        </strong>
      </p>
      <ol start={7}>
        <li>
          <strong>
            {" "}
            Cancellations, Class Issues, and Booking Modifications
          </strong>
          .
        </li>
      </ol>
      <p>
        <strong>7.1 Cancellations and Class Issues</strong>. In general, if a
        User cancels a reservation, the amount paid to you is determined by the
        cancellation policy that applies to that reservation. As an Instructor,
        you should only cancel on a User with a valid reason or applicable law.
        If you cancel on a User without such a valid reason, we may impose a
        cancellation fee based on our{" "}
        <a href={createAppLink("/policies/instructor-cancellation")}>
          Instructor Cancellation policy
        </a>
        . If (i) a User experiences a Class Issue (as defined by the&nbsp;
        <a href={createAppLink("/policies/user-refund")}>User Refund Policy</a>)
        or (ii) a reservation is canceled under Section 13 of these Terms, the
        amount you are paid will be reduced by the amount we refund or otherwise
        provide to the User and by any other reasonable costs we incur as a
        result of the cancellation. Suppose that a User receives a refund after
        you have already been paid, or the amount of the refund and other costs
        incurred by Teache exceeds your payout. In that case, Teache may recover
        that amount from you by offsetting the refund against your future
        payouts. You agree that Teache's&nbsp;
        <a href={createAppLink("/policies/user-refund")}>
          User Refund Policy
        </a>{" "}
        and these Terms preempt the cancellation policy you set in situations
        where they allow for the cancellation of a reservation and/or the
        issuance of refunds to Users. Suppose we reasonably expect to provide a
        refund to a User under one of these policies. In that case, we may delay
        the release of any payout for that reservation until a refund decision
        is made.
      </p>
      <p>
        <strong>7.2 Booking Modifications</strong>. Instructors and Users are
        responsible for any Class Booking Modifications they agree to make via
        the Teache Platform or which they direct Teache customer service to make
        on their behalf. They agree to pay any additional amounts, fees, or
        taxes associated with a Class Booking Modification.
      </p>
      <ol start={8}>
        <li>
          <strong> Taxes</strong>.
        </li>
      </ol>
      <p>
        <strong>8.1 Instructor Taxes</strong>. As an Instructor, you are
        responsible for determining and fulfilling your obligations under
        applicable laws to report, collect, remit, or include in your price any
        applicable VAT or other indirect taxes, occupancy taxes, income, or
        other taxes ("<strong>Taxes</strong>").
      </p>
      <p>
        <strong>8.2</strong> <strong>Geographic Restrictions. </strong>The owner
        of the Platform is based in the State of New York in the United States.
        We make no claims that the Platform or any of its content is accessible
        or appropriate outside of the United States, including taxes outside of
        the United States. Access to the Platform may not be legal by certain
        persons or in certain countries. If you access the Platform from outside
        the United States, you do so on your own initiative and are responsible
        for tax compliance with local laws.
      </p>
      <p>
        <strong>General Terms</strong>
      </p>
      <ol start={9}>
        <li>
          <strong> Reviews</strong>.
        </li>
      </ol>
      <p>
        After each Class, Users and Instructors will have an opportunity to
        review each other. Your Review must be accurate and may not contain any
        discriminatory, offensive, defamatory, or other language that violates
        our&nbsp;<a href={createAppLink("/policies/content")}>Content Policy</a>
        &nbsp;or&nbsp;
        <a href={createAppLink("reviews")}>Review Policy</a>. Reviews are not
        verified by Teache for accuracy and may be incorrect or misleading.
      </p>
      <ol start={10}>
        <li>
          <strong> Content</strong>.
        </li>
      </ol>
      <p>
        Parts of the Teache Platform enable you to provide feedback, text,
        photos, audio, video, information, and other content (collectively,
        &ldquo;<strong>Content</strong>&rdquo;). By providing Content, in
        whatever form and through whatever means, you grant Teache a
        non-exclusive, worldwide, royalty-free, irrevocable, perpetual,
        sub-licensable and transferable license to copy, modify, prepare
        derivative works of, distribute, publish and otherwise exploit that
        Content without limitation. If Content includes personal information,
        our&nbsp;
        <a href={createAppLink("/policies/privacy-policy")}>Privacy Policy</a>
        &nbsp;describes how we use that personal information. Where Teache pays
        for the creation of Content or facilitates its creation, Teache may own
        that Content (in which case, supplemental terms or disclosures will
        state that). You are solely responsible for all Content that you provide
        and warrant that you either own it or are authorized to grant Teache the
        rights described in these Terms. You are responsible and liable if any
        of your Content violates or infringes the intellectual property or
        privacy rights of any third party. Content must comply with our&nbsp;
        <a href={createAppLink("/policies/content")}>Content Policy</a> which
        prohibits, among other things, discriminatory, obscene, harassing,
        deceptive, violent, and illegal content. You agree that Teache may make
        available services or automated tools to translate Content and that your
        Content may be translated using such services or tools. Teache does not
        guarantee the accuracy or quality of translations, and Members are
        responsible for confirming the accuracy of such translations.
      </p>
      <ol start={11}>
        <li>
          <strong> Fees</strong>.
        </li>
      </ol>
      <p>
        Teache may charge fees (and applicable Taxes) to Instructors and Users
        for using the Teache Platform. Except as otherwise provided on the
        Teache Platform, service fees are non-refundable. Teache reserve the
        right to change their service fees at any time and will notify Members
        of any fee changes before they become effective. Fee changes will not
        affect bookings made before the effective date of the fee change. If you
        disagree with a fee change, you may terminate this agreement at any time
        pursuant to Section 13.2.
      </p>
      <ol start={12}>
        <li>
          <strong> Teache Platform Rules</strong>.
        </li>
      </ol>
      <p>
        <strong>12.1 Rules</strong>. You must follow these rules and must not
        help or induce others to break or circumvent these rules:
      </p>
      <ul>
        <li>Act with integrity and treat others with respect</li>
        <ul>
          <li>
            Do not lie, misrepresent something or someone, or pretend to be
            someone else.
          </li>
          <li>
            Be polite and respectful when you communicate or interact with
            others.
          </li>
          <li>Do not discriminate against or harass others.</li>
        </ul>
        <li>
          Do not scrape, hack, reverse engineer, compromise, or impair the
          Teache Platform
        </li>
        <ul>
          <li>
            Do not use bots, crawlers, scrapers, or other automated means to
            access or collect data or other content from or otherwise interact
            with the Teache Platform.
          </li>
          <li>
            Do not hack, avoid, remove, impair, or otherwise attempt to
            circumvent any security or technological measures used to protect
            the Teache Platform or Content.
          </li>
          <li>
            Do not decipher, decompile, disassemble, or reverse engineer any of
            the software or hardware used to provide the Teache Platform.
          </li>
          <li>
            Do not take any action that could damage or adversely affect the
            performance or proper functioning of the Teache Platform.
          </li>
        </ul>
        <li>
          Only use the Teache Platform as authorized by these Terms or another
          agreement with us
        </li>
        <ul>
          <li>
            You may only use another Member&rsquo;s personal information as
            necessary to facilitate a transaction using the Teache Platform as
            authorized by these Terms.
          </li>
          <li>
            Do not use the Teache Platform, our messaging tools, or
            Members&rsquo; personal information to send commercial messages
            without the recipient&rsquo;s express consent.
          </li>
          <li>
            You may use Content made available through the Teache Platform
            solely as necessary to enable your use of the Teache Platform as a
            User or Instructor.
          </li>
          <li>
            Do not use Content unless you have permission from the Content owner
            or the Content&rsquo;s use is authorized by us in these Terms or
            another agreement you have with us.
          </li>
          <li>
            Only request, make or accept a booking or any payment within the
            Teache Platform to avoid paying fees, taxes, or other reasons.
          </li>
          <li>
            Do not require or encourage Users to open an account, leave a
            review, complete a survey, or otherwise interact with a third-party
            website, application, or service before, during, or after a
            reservation, unless authorized by Teache.
          </li>
          <li>
            Do not engage in practices intended to manipulate our search
            algorithm.
          </li>
          <li>
            Only book Instructor Services if you truly intend to use those
            Instructor Services.
          </li>
          <li>
            Do not use, copy, display, mirror, or frame the Teache Platform, any
            Content, any Teache branding, or any page layout or design without
            our consent.
          </li>
        </ul>
        <li>Honor your legal obligations</li>
        <ul>
          <li>
            Understand and follow the laws that apply to you, including privacy,
            data protection, and export laws.
          </li>
          <li>
            Provide us with someone else&rsquo;s personal information. You (i)
            must do so in compliance with applicable law, (ii) must be
            authorized to do so, and (iii) authorize us to process that
            information under our&nbsp;
            <a href={createAppLink("/policies/privacy-policy")}>
              Privacy Policy
            </a>
            .
          </li>
          <li>
            Read and follow our Terms and&nbsp;
            <a href={createAppLink("/policies/community-standards")}>
              Community Standards
            </a>
            .
          </li>
          <li>
            Do not use the name, logo, branding, or trademarks of Teache or
            others without permission.
          </li>
          <li>
            Do not use or register any domain name, social media handle, trade
            name, trademark, branding, logo, or other source identifiers that
            may be confused with Teache branding.
          </li>
          <li>
            Do not offer Instructor Services that violate the laws or agreements
            that apply to you.
          </li>
          <li>
            Do not offer or solicit prostitution or participate in or facilitate
            human trafficking.
          </li>
        </ul>
      </ul>
      <p>
        <strong>12.2 Reporting Violations</strong>. If you believe that a
        Member, Listing, or Content poses an imminent risk of harm to a person
        or property, you should immediately contact local authorities before
        contacting Teache. In addition, if you believe that a Member, Listing,
        or Content has violated our&nbsp;
        <a href={createAppLink("/policies/community-standards")}>
          Community Standards
        </a>
        , you should report your concerns to Teache. If you report an issue to
        local authorities, Teache may request a copy of that report. Except as
        required by law, you agree that we are not obligated to take action in
        response to any report.
      </p>
      <p>
        <strong>12.3 Copyright Notifications</strong>. If you believe that
        Content on the Teache Platform infringes on copyrights, please notify us
        in accordance with our&nbsp;
        <a href={createAppLink("/policies/copyright")}>Copyright Policy</a>.
      </p>
      <ol start={13}>
        <li>
          <strong> Termination, Suspension, and Other Measures</strong>.
        </li>
      </ol>
      <p>
        <strong>13.1 Term</strong>. The agreement between you and Teache
        reflected by these Terms is effective when you access the Teache
        Platform (e.g., to create an account) and remains in effect until either
        you or we terminate the agreement in accordance with these Terms.
      </p>
      <p>
        <strong>13.2 Termination</strong>. You may terminate this agreement at
        any time by sending us&nbsp; an email&nbsp;or by deleting your account.
        Teache may terminate this agreement and your account for any reason by
        giving you a notice via email or using any other contact information you
        have provided for your account. Teache may also terminate this agreement
        immediately and without notice and stop providing access to the Teache
        Platform if you breach these Terms, violate our Policies, or violate
        applicable laws or if we reasonably believe termination is necessary to
        protect Teache, its Members, or third parties. If your account has been
        inactive for more than two years, we may terminate your account without
        prior notice.
      </p>
      <p>
        <strong>13.3 Member Violations</strong>. If (i) you breach these Terms,
        our Policies, or our&nbsp;
        <a href={createAppLink("/policies/community-standards")}>
          Community Standards
        </a>
        , (ii) you violate applicable laws, regulations, or third-party rights,
        or (iii) Teache believes it is reasonably necessary to protect Teache,
        its Members, or third parties; Teache may, with or without prior notice:
      </p>
      <ul>
        <li>
          suspend or limit your access to or use of the Teache Platform and/or
          your account;
        </li>
        <li>suspend or remove Listings, Reviews, or other Content;</li>
        <li>cancel pending or confirmed bookings; or</li>
        <li>
          suspend or revoke any special status associated with your account.
        </li>
      </ul>
      <p>
        For minor violations or where otherwise appropriate, as Teache
        determines in its sole discretion, you will be given notice of any
        intended measure by Teache. You will be afforded an opportunity to
        resolve the issue. You may appeal actions that we took under this
        Section by contacting customer service. Suppose that a reservation is
        canceled under this Section. In that case, the amount paid to the
        Instructor will be reduced by the amount we refund or otherwise provide
        to the User and will be further reduced by any other costs we incur as a
        result of the cancellation.
      </p>
      <p>
        <strong>13.4 Legal Mandates</strong>. Teache may take any action it
        determines is reasonably necessary to comply with applicable law or the
        order or request of a court, law enforcement, or other administrative
        agency or governmental body, including the measures described above in
        Section 13.3.
      </p>
      <p>
        <strong>13.5 Effect of Termination</strong>. If you are an Instructor
        and terminate your Teache account, any confirmed booking(s) will be
        automatically canceled, and your Users will receive a full refund. If
        you terminate your account as a User, any confirmed booking(s) will be
        automatically canceled, and any refund will depend upon the terms of the
        reservation&rsquo;s cancellation policy. When this agreement has been
        terminated, you are not entitled to a restoration of your account or any
        of your Content. Suppose that your access to or use of the Teache
        Platform has been limited, or your Teache account has been suspended, or
        we have terminated this agreement. In that case, you may not register a
        new account or access or use the Teache Platform through an account of
        another Member.
      </p>
      <p>
        <strong>13.6 Survival</strong>. Parts of these Terms will survive
        termination of this agreement, including Sections 2 through 26.
      </p>
      <ol start={14}>
        <li>
          <strong> Modification</strong>.
        </li>
      </ol>
      <p>
        Teache may modify these Terms at any time. When we make material changes
        to these Terms, we will post the revised Terms on the Teache Platform
        and update the &ldquo;Last Updated&rdquo; date at the top of these
        Terms. We will also notify you of any material changes by email at least
        30 days before the date they become effective. If you disagree with the
        revised Terms, you may terminate this agreement immediately, as provided
        in these Terms. If you do not terminate your agreement before the date
        the revised Terms become effective, your continued access to or use of
        the Teache Platform will constitute acceptance of the revised Terms.
      </p>
      <ol start={15}>
        <li>
          <strong> Resolving Complaints and Damage Claims</strong>.
        </li>
      </ol>
      <p>
        If a Member provides evidence that another Member damaged their real or
        personal property ("<strong>Damage Claim</strong>"), the complaining
        Member can seek compensation. If the complaining Member escalates a
        Damage Claim to Teache, the other Member will be given an opportunity to
        respond. Suppose that the responding Member agrees to pay, or Teache
        determines in its sole discretion that they are responsible for the
        Damage Claim. In that case, Teache can collect any sums required to
        cover the Damage Claim from the responding Member and/or against any
        security deposit. You agree that Teache may seek to recover from you
        under any insurance policies you maintain and that Teache may also
        pursue against you any remedies it may have available under applicable
        law. You agree to cooperate in good faith, provide any information
        Teache requests, execute documents, and take further reasonable action
        in connection with Damage Claims, Member complaints, claims under
        insurance policies, or other claims related to your provision or use of
        Instructor Services.
      </p>
      <ol start={16}>
        <li>
          <strong> Teache's Role</strong>.
        </li>
      </ol>
      <p>
        We offer a platform that enables Members to publish, offer, search for,
        and book Classes. While we work hard to ensure that our Members have
        great experiences while using Teache, we do not and cannot control the
        conduct of Users and Instructors. You acknowledge that Teache has the
        right, but is not obligated, to monitor the use of the Teache Platform
        and verify information provided by our Members. For example, we may
        review, disable access to, remove, or edit Content to (i) operate,
        secure, and improve the Teache Platform (including for fraud prevention,
        risk assessment, investigation, and customer support purposes); (ii)
        ensure Members&rsquo; compliance with these Terms; (iii) comply with
        applicable law or the order or requirement of a court, law enforcement
        or other administrative agency or governmental body; (iv) address
        Content that we determine is harmful or objectionable; (v) take actions
        set out in these Terms; and (vi) maintain and enforce any quality or
        eligibility criteria, including by removing Listings that don&rsquo;t
        meet quality and eligibility criteria. Members acknowledge and agree
        that Teache administers its Policies and&nbsp;
        <a href={createAppLink("/policies/community-standards")}>
          Community Standards
        </a>
        &nbsp;(such as&nbsp;
        <a href={createAppLink("/policies/instructor-requirements")}>
          basic requirements for Instructors
        </a>
        ), including decisions about whether and how to apply them to a
        particular situation, at its sole discretion. Members agree to cooperate
        with and assist Teache in good faith to provide Teache with such
        information, and take such actions as may be reasonably requested by
        Teache with respect to any investigation undertaken by Teache regarding
        the use or abuse of the Teache Platform. Teache is not acting as an
        agent for any Member, except for where Teache acts as a collection agent
        as provided in the Payments Terms.
      </p>
      <ol start={17}>
        <li>
          <strong> Member Accounts</strong>.
        </li>
      </ol>
      <p>
        You must register an account to access and use many features of the
        Teache Platform. Registration is only permitted for legal entities,
        partnerships, and natural persons who are 18 years or older. You
        represent and warrant that you are not a person or entity barred from
        using the Teache Platform under the laws of the United States, your
        place of residence, or any other applicable jurisdiction. You must
        provide accurate, current, and complete information during registration
        and keep your account information up to date. You may not register more
        than one account or transfer your account to someone else. You are
        responsible for maintaining the confidentiality and security of your
        account credentials and may not disclose your credentials to any third
        party. You are responsible and liable for activities conducted through
        your account. You must immediately notify Teache if you suspect your
        credentials have been lost or stolen or your account is compromised. If
        and as permitted by applicable law, we may, but have no obligation to,
        (i) ask you to provide identification or other information, (ii)
        undertake checks designed to help verify your identity or background,
        (iii) screen you against third-party databases or other sources and
        request reports from service providers, and (iv) obtain reports from
        public records of criminal convictions or sex offender registrations or
        their local equivalents.&nbsp; BY USING THE TEACHE PLATFORM, INCLUDING
        BY OPENING A MEMBER ACCOUNT, OR BY ACCEPTING A CLASS THROUGH THE TEACHE
        PLATFORM, YOU AFFIRM THAT YOU ARE OF LEGAL AGE TO ENTER INTO THIS
        AGREEMENT, AND YOU AGREE TO THESE TERMS. THESE TERMS ALSO GOVERN THE
        RELATIONSHIP BETWEEN YOU AND A INSTRUCTOR IN CONNECTION WITH CLASSES
        THAT YOU ACCEPT. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT USE OUR
        TEACHE PLATFORM.
      </p>
      <ol start={18}>
        <li>
          <strong> Disclaimer of Warranties</strong>.
        </li>
      </ol>
      <p>
        <strong>
          We provide the Teache Platform and all Content &ldquo;as is&rdquo;
          without warranty of any kind and we disclaim all warranties, whether
          express or implied. This means that, for example, (i) we do not
          endorse or warrant the existence, conduct, performance, safety,
          quality, legality or suitability of any User, Instructor, Classes,
          Listing, or third party; (ii) we do not warrant the performance or
          non-interruption of the Teache Platform; and (iii) we do not warrant
          that verification, identity or background checks conducted on Listings
          or Members (if any) will identify past misconduct or prevent future
          misconduct. Any references to a Member or Listing being "verified" (or
          similar language) indicate only that the Member, Listing, or Teache
          has completed a relevant verification or identification process and
          nothing else. The disclaimers in these Terms apply to the maximum
          extent permitted by law. If you have statutory rights or warranties,
          we cannot disclaim the duration of any such statutorily required
          rights or warranties will be limited to the maximum extent permitted
          by law.
        </strong>
      </p>
      <ol start={19}>
        <li>
          <strong> Limitations on Liability</strong>.
        </li>
      </ol>
      <p>
        <strong>
          Neither Teache (including its affiliates and personnel) nor any other
          party involved in creating, producing, or delivering the Teache
          Platform or any Content will be liable for any incidental, special,
          exemplary or consequential damages, including lost profits, loss of
          data or loss of goodwill, service interruption, computer damage or
          system failure or the cost of substitute products or services, or for
          any damages for personal or bodily injury or emotional distress
          arising out of or in connection with (i) these Terms, (ii) the use of
          or inability to use the Teache Platform or any Content, (iii) any
          communications, interactions, or meetings you may have with someone
          you interact or meet with through, or as a result of, your use of the
          Teache Platform, or (iv) publishing or booking of a Class, including
          the provision or use of Instructor Services, whether based on
          warranty, contract, tort (including negligence), product liability or
          any other legal theory, and whether or not Teache has been informed of
          the possibility of such damage, even if a limited remedy set out in
          these Terms is found to have failed its essential purpose.
        </strong>
      </p>
      <p>
        <strong>
          Except for our obligation to transmit payments to Instructors under
          these Terms, in no event will Teache's aggregate liability for any
          claim or dispute arising out of or in connection with these Terms,
          your interaction with any Members, or your use of or inability to use
          the Teache Platform, any Content, or any Instructor Service exceed:
          (A) to Users, the amount you paid as a User during the 12-month period
          before the event giving rise to the liability; (B) to Instructors, the
          amount paid to you as an Instructor in the 12-month period before the
          event giving rise to the liability; or (C) to anyone else, one hundred
          U.S. dollars (US$100).
        </strong>
      </p>
      <p>
        <strong>
          These limitations of liability and damages are fundamental elements of
          the agreement between you and Teache. If applicable law does not allow
          the limitations of liability set out in these Terms, the above
          limitations may not apply to you.
        </strong>
      </p>
      <ol start={20}>
        <li>
          <strong> Indemnification</strong>.
        </li>
      </ol>
      <p>
        <strong>
          To the maximum extent permitted by applicable law, you agree to
          release, defend (at Teache's option), indemnify, and hold Teache
          (other affiliates, and their personnel) harmless from and against any
          claims, liabilities, damages, losses, and expenses, including, without
          limitation, reasonable legal and accounting fees, arising out of or in
          any way connected with (i) your breach of these Terms (including any
          supplemental or additional terms that apply to a product or feature)
          or our&nbsp;
        </strong>
        <strong>Policies</strong>
        <strong>&nbsp;or&nbsp;</strong>
        <strong>
          <a href={createAppLink("/policies/community-standards")}>
            Community Standards
          </a>
        </strong>
        <strong>
          , (ii) your improper use of the Teache Platform, (iii) your
          interaction with any Member or participation in a Class or other
          Instructor Service, including, without limitation, any injuries,
          losses or damages (whether compensatory, direct, incidental,
          consequential or otherwise) of any kind arising in connection with or
          as a result of such interaction, participation or use, (iv) your
          failure, or our failure at your direction, to accurately report,
          collect or remit Taxes, or (v) your breach of any laws, regulations,
          or third-party rights, such as intellectual property or privacy
          rights.
        </strong>
      </p>
      <ol start={21}>
        <li>
          <strong> Contracting Entities</strong>.
        </li>
      </ol>
      <p>
        Based on your country of residence or establishment and what you are
        doing on the Teache Platform, Schedule 1 (see below) establishes the
        Teache entity with whom you are contracting. If we identify, through the
        Teache Platform, a Teache entity other than the one established in
        Schedule 1 as being responsible for a product, feature, or transaction,
        the Teache entity so identified is your contracting entity with respect
        to that product, feature, or transaction. Suppose that you change your
        country of residence or establishment. In that case, the Teache company
        you contract with (as established in Schedule 1), and the applicable
        version of the Terms of Use will be determined by your new country of
        residence or establishment from the date on which your country of
        residence or establishment changes.
      </p>
      <ol start={22}>
        <li>
          <strong> United States Governing Law and Venue</strong>.
        </li>
      </ol>
      <p>
        Suppose that you reside or have your place of establishment in the
        United States. In that case, these Terms will be interpreted in
        accordance with the laws of the State of New York and the United States
        of America, without regard to conflict-of-law provisions. Judicial
        proceedings (other than small claims actions) that are excluded from the
        arbitration agreement in Section 23 must be brought in state or federal
        court in New York City, New York, unless you and Teache both agree to a
        different location. You and Teache both consent to venue and personal
        jurisdiction in New York City, New York.
      </p>
      <ol start={23}>
        <li>
          <strong>
            United States Dispute Resolution and Arbitration Agreement
          </strong>
          .
        </li>
      </ol>
      <p>
        <strong>23.1 Application</strong>. This Arbitration Agreement only
        applies to you if your country of residence or establishment is the
        United States. Suppose that your country of residence or establishment
        is not the United States, and you nevertheless attempt to bring any
        legal claim against Teache in the United States. In that case, this
        Arbitration Agreement will apply for the determination of the threshold
        issue of whether this Section 23 applies to you and all other threshold
        determinations, including residency, arbitrability, venue, and
        applicable law.
      </p>
      <p>
        <strong>23.2 Overview of Dispute Resolution Process</strong>. Teache is
        committed to participating in a consumer-friendly dispute resolution
        process. To that end, these Terms provide for a two-part process for
        individuals to whom this Section 23 applies: (1) An informal negotiation
        directly with Teache's customer service team (described in paragraph
        23.3, below), and, if necessary, (2) A binding arbitration administered
        by the American Arbitration Association (&ldquo;<strong>AAA</strong>
        &rdquo;). You and Teache each retain the right to seek relief in small
        claims court as an alternative to arbitration.
      </p>
      <p>
        <strong>
          23.3 Mandatory Pre-Arbitration Dispute Resolution and Notification
        </strong>
        . At least 30 days prior to initiating an arbitration, you and Teache
        each agree to notify the other party of the dispute in writing and
        attempt in good faith to negotiate an informal resolution. You must send
        your notice of the dispute to Teache by mailing it to Teache's agent for
        service at&nbsp;
        <strong>
          Northwest Registered Agent, 7901 4th Street N, Suite 300, St
          Petersburg FL, 33702.
        </strong>{" "}
        Teache will send its notice of the dispute to the email address
        associated with your Teache account. A notice of dispute must include
        the party&rsquo;s name and preferred contact information, a brief
        description of the dispute, and the relief sought. If the parties are
        unable to resolve the dispute within the 30-day period, only then may
        either party commence the arbitration by filing a written Demand for
        Arbitration (available at&nbsp;www.adr.org) with the AAA and providing a
        copy to the other party, as specified in the AAA Rules (available
        at&nbsp;www.adr.org).
      </p>
      <p>
        <strong>23.4 Agreement to Arbitrate</strong>.&nbsp;
        <strong>
          You and Teache mutually agree that any dispute, claim, or controversy
          arising out of or relating to these Terms or the applicability,
          breach, termination, validity, enforcement, or interpretation thereof,
          or any use of the Teache Platform, Instructor Services, or any Content
          (collectively, &ldquo;
        </strong>
        Disputes
        <strong>
          &rdquo;) will be settled by binding individual arbitration (the
          &ldquo;
        </strong>
        Arbitration Agreement
        <strong>
          &rdquo;). If there is a dispute about whether this Arbitration
          Agreement can be enforced or applies to our Dispute, you and Teache
          agree that the arbitrator will decide that issue.
        </strong>
      </p>
      <p>
        <strong>23.5 Exceptions to Arbitration Agreement</strong>. You and
        Teache each agree that the following causes of action and/or claims for
        relief are exceptions to the Arbitration Agreement and will be brought
        in a judicial proceeding in a court of competent jurisdiction (as
        defined by Section 22): (i) any claim or cause of action alleging actual
        or threatened infringement, misappropriation, or violation of a
        party&rsquo;s copyrights, trademarks, trade secrets, patents, or other
        intellectual property rights; (ii) any claim or cause of action seeking
        emergency injunctive relief based on exigent circumstances (e.g.,
        imminent danger or commission of a crime, hacking, cyber-attack); or
        (iii) a request for the remedy of public injunctive relief. You and
        Teache agree that the remedy of public injunctive relief will proceed
        after the arbitration of all arbitrable claims, remedies, or causes of
        action and will be stayed pending the outcome of the arbitration
        pursuant to section 3 of the Federal Arbitration Act.
      </p>
      <p>
        <strong>23.6 Arbitration Rules and Governing Law</strong>. This
        Arbitration Agreement evidences a transaction in interstate commerce,
        and the Federal Arbitration Act governs all substantive and procedural
        interpretation and enforcement of this provision. The arbitration will
        be administered by AAA in accordance with the Consumer Arbitration Rules
        and/or other AAA arbitration rules determined to be applicable by the
        AAA (the &ldquo;<strong>AAA Rules</strong>&ldquo;) then in effect,
        except as modified here. The AAA Rules are available at&nbsp;
        www.adr.org. To initiate arbitration, a completed written demand
        (available at&nbsp; www.adr.org) must be filed with the AAA and provided
        to the other party, as specified in the AAA rules.
      </p>
      <p>
        <strong>
          23.7 Modification to AAA Rules - Arbitration Hearing/Location
        </strong>
        . To make the arbitration more convenient for you, Teache agrees that
        any required arbitration hearing may be conducted, at your choosing, (a)
        in the U.S. County where you reside; (b) in Miami-Dade County; (c) via
        phone or video conference; or (d) if all parties agree, solely by the
        submission of documents to the arbitrator.
      </p>
      <p>
        <strong>
          23.8 Modification of AAA Rules - Attorney&rsquo;s Fees and Costs
        </strong>
        . Your arbitration fees and your share of arbitrator compensation shall
        be governed by the AAA Rules and, where appropriate, will be limited by
        the AAA Consumer Rules. If such costs are determined by the arbitrator
        to be excessive, Teache will pay all arbitration fees and expenses.
        Either party may make a request that the arbitrator award
        attorneys&rsquo; fees and costs upon proving that the other party has
        asserted a claim, crossclaim, or defense that is groundless in fact or
        law, brought in bad faith or for the purpose of harassment, or is
        otherwise frivolous, as allowed by applicable law and the AAA Rules.
      </p>
      <p>
        <strong>23.9 Arbitrator&rsquo;s Decision</strong>. The
        arbitrator&rsquo;s decision will include the essential findings and
        conclusions upon which the arbitrator based the award. Judgment on the
        arbitration award may be entered in any court with proper jurisdiction.
        The arbitrator may award any relief allowed by law or the AAA Rules.
        Declaratory or injunctive relief may still be awarded only on an
        individual basis and only to the extent necessary to provide relief
        warranted by the claimant&rsquo;s individual claim.
      </p>
      <p>
        <strong>23.10 Jury Trial Waiver</strong>. You and Teache acknowledge and
        agree that each party waives the right to a trial by jury as to all
        arbitrable Disputes.
      </p>
      <p>
        <strong>23.11 No Class Actions or Representative Proceedings</strong>.
        You and Teache acknowledge and agree that, to the fullest extent
        permitted by law, each party waives the right to participate as a
        plaintiff or class member in any purported class-action lawsuit,
        class-wide arbitration, private attorney general action, or any other
        representative or consolidated proceeding. Unless you and Teache agree
        in writing, the arbitrator may not consolidate more than one
        party&rsquo;s claims and may not otherwise preside over any form of any
        class or representative proceeding. If there is a final judicial
        determination that applicable law precludes enforcement of the waiver
        contained in this paragraph as to any claim, cause of action or
        requested remedy, then that claim, cause of action or requested remedy,
        and only that claim, cause of action or requested remedy, will be
        severed from this agreement to arbitrate and will be brought in a court
        of competent jurisdiction. In the event that a claim, cause of action,
        or requested remedy is severed pursuant to this paragraph, then you and
        Teache agree that the claims, causes of action, or requested remedies
        that are not subject to arbitration will be stayed until all arbitrable
        claims, causes of action, and requested remedies are resolved by the
        arbitrator.
      </p>
      <p>
        <strong>23.12 Severability</strong>. Except as provided in Section
        23.11, in the event that any portion of this Arbitration Agreement is
        deemed illegal or unenforceable, such provision will be severed, and the
        remainder of the Arbitration Agreement will be given full force and
        effect.
      </p>
      <p>
        <strong>23.13 Changes to Agreement to Arbitrate</strong>. Suppose Teache
        changes this Section 23 after the date you last accepted these Terms (or
        accepted any subsequent changes to these Terms). In that case, you may
        reject that change by sending us written notice (including by email)
        within 30 days of the date the change is effective. Rejecting a new
        change, however, does not revoke or alter your prior consent to any
        earlier agreements to arbitrate any Dispute between you and Teache (or
        your prior consent to any subsequent changes thereto), which will remain
        in effect and enforceable as to any Dispute between you and Teache.
      </p>
      <p>
        <strong>23.14 Survival</strong>. Except as provided in Section 23.12 and
        subject to Section 13.6, this Section 23 will survive any termination of
        these Terms. It will continue to apply, even if you stop using the
        Teache Platform or terminate your Teache account.
      </p>
      <ol start={24}>
        <li>
          <strong> Miscellaneous</strong>.
        </li>
      </ol>
      <p>
        <strong>24.1 Other Terms Incorporated by Reference</strong>. Our{" "}
        <a href={createAppLink("/policies/user-refund")}>User Refund Policy</a>,{" "}
        <a href={createAppLink("/policies/content")}>Content Policy</a>,{" "}
        <a href={createAppLink("/policies/community-standards")}>Standards</a>,
        and other supplemental policies and terms linked to these Terms apply to
        your use of the Teache Platform, are incorporated by reference and form
        part of your agreement with Teache.
      </p>
      <p>
        <strong>24.2 Interpreting these Terms</strong>. Except as additional
        terms may supplement them, conditions, policies, guidelines, standards,
        and in-product disclosures, these Terms (including those items
        incorporated by reference) constitute the entire agreement between you
        and Teache pertaining to your access to or use of the Teache Platform
        and supersede any and all prior oral or written understandings or
        agreements between you and Teache. These Terms do not and are not
        intended to confer any rights or remedies upon anyone other than you and
        Teache. Suppose that any provision of these Terms is held to be invalid
        or unenforceable, except as otherwise indicated in Section 23.11 above.
        In that case, such a provision will be struck and will not affect the
        validity and enforceability of the remaining provisions. Where the word
        &ldquo;will&rdquo; is used in these Terms, it connotes an obligation
        with the same meaning as &ldquo;shall.&rdquo;
      </p>
      <p>
        <strong>24.3 No Waiver</strong>. Teache's failure to enforce any right
        or provision in these Terms will not constitute a waiver of such right
        or provision, unless acknowledged and agreed to by us in writing. Except
        as expressly outlined in these Terms, the exercise by either party of
        any of its remedies under these Terms will be without prejudice to its
        other remedies under these Terms or otherwise permitted under law.
      </p>
      <p>
        <strong>24.4 Assignment</strong>. You may not assign, transfer, or
        delegate this agreement or your rights and obligations hereunder without
        Teache's prior written consent. Teache may, without restriction, assign,
        transfer, or delegate this agreement and any rights and obligations
        hereunder, at its sole discretion, with 30 days prior notice.
      </p>
      <p>
        <strong>24.5 Notice</strong>. Unless specified otherwise, any notices or
        other communications to Members permitted or required under this
        agreement will be provided electronically and given by Teache via email,
        Teache Platform notification, messaging service (including SMS), or any
        other contact method enabled by us and provided by you.
      </p>
      <p>
        <strong>24.6 Third-Party Services</strong>. The Teache Platform may
        contain links to third-party websites, applications, services, or
        resources (&ldquo;<strong>Third-Party Services</strong>&rdquo;) that are
        subject to different terms and privacy practices. Teache is not
        responsible or liable for any aspect of such Third-Party Services, and
        links to such Third-Party Services are not an endorsement.
      </p>
      <p>
        <strong>24.7 Teache Platform Content</strong>. Content made available
        through the Teache Platform may be protected by copyright, trademark,
        and/or other laws of the United States and other countries. You
        acknowledge that all intellectual property rights for such Content are
        the exclusive property of Teache and/or its licensors and agree that you
        will not remove, alter, or obscure any copyright, trademark, service
        mark, or other proprietary rights notices. You may not use, copy, adapt,
        modify, prepare derivative works of, distribute, license, sell,
        transfer, publicly display, publicly perform, transmit, broadcast, or
        otherwise exploit any Content accessed through the Teache Platform,
        except to the extent you are the legal owner of that Content or as
        expressly permitted in these Terms. Subject to your compliance with
        these Terms, Teache grants you a limited, non-exclusive,
        non-sublicensable, revocable, non-transferable license to (i) download
        and use the Application on your personal device(s); and (ii) access and
        view the Content made available on or through the Teache Platform and
        accessible to you, solely for your personal and non-commercial use.
      </p>
      <p>
        <strong>24.8 Emails and SMS</strong>. You will receive administrative
        communications from us using the email address or other contact
        information you provide for your Teache account. Enrollment in
        additional email subscription programs will not affect the frequency of
        these administrative emails. However, you should expect to receive
        additional emails specific to the program(s) to which you have
        subscribed. You may also receive promotional emails from us. No fee is
        charged for these promotional emails, but third-party data rates could
        apply. You can control whether or not you receive promotional emails
        using the notification preferences in your account settings. Please note
        that you can only take advantage of certain promotions, if you disable
        certain communication settings or have a Teache account. In the U.S., if
        you consent to receive SMS (text messages) from us, you will be subject
        to our&nbsp;<a href={createAppLink("/policies/sms-terms")}>SMS Terms</a>
        .
      </p>
      <p>
        <strong>24.9 Contact Us</strong>. If you have any questions about these
        Terms, please&nbsp;email us at hello@teache.co.
      </p>
      <p id='schedule-1'>
        <strong>Schedule 1 - Contracting Entities</strong>
      </p>
      <div className='termsTableContainer hide-scrollbar'>
        <table className='table'>
          <thead>
            <tr>
              <td>
                <p>
                  <strong>Place of Residence or Establishment:</strong>
                </p>
              </td>
              <td>
                <p>
                  <strong>Activities on Teache platform:</strong>
                </p>
              </td>
              <td>
                <p>
                  <strong>Teache Contracting Entity:</strong>
                </p>
              </td>
              <td>
                <p>
                  <strong>Contact Information:</strong>
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan={3}>
                <p>
                  <strong>United States</strong>
                </p>
              </td>
              <td>
                <p>Booking or offering classes located in the United States.</p>
              </td>
              <td>
                <p>Teache, Inc.</p>
              </td>
              <td>
                <p>79 Madison Ave. New York, NY 10016, United States</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <strong>&nbsp;</strong>
      </p>
      <p>&nbsp;</p>
    </>
  )
}

export default Terms
